var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"title text-blue"},[_vm._v("You're "+_vm._s(_vm.value)+"% done")]),_vm._v(" "),_c('progress',{attrs:{"max":"100"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }